var config = process.env;

export const BRANCH_STORAGE_KEY = 'selectedBranchId';
const BRANCH_LIST_CACHE_KEY = 'branchListCache';
const BRANCH_LIST_CACHE_TTL_MS = 30 * 60 * 1000;
const BRANCH_SETTINGS_CACHE_KEY = 'branchSettingsCache';
const BRANCH_SETTINGS_CACHE_TTL_MS = 30 * 1000;

export function getSelectedBranchId() {
    return localStorage.getItem(BRANCH_STORAGE_KEY);
}

export function setSelectedBranchId(branchId) {
    if (branchId == null || branchId === '') {
        localStorage.removeItem(BRANCH_STORAGE_KEY);
        return;
    }

    localStorage.setItem(BRANCH_STORAGE_KEY, String(branchId));
}

export function getCachedBranches() {
    const rawCache = localStorage.getItem(BRANCH_LIST_CACHE_KEY);
    if (!rawCache) {
        return null;
    }

    try {
        const parsedCache = JSON.parse(rawCache);
        if (!parsedCache || !Array.isArray(parsedCache.branches) || parsedCache.expiresAt <= Date.now()) {
            localStorage.removeItem(BRANCH_LIST_CACHE_KEY);
            return null;
        }

        return parsedCache.branches;
    } catch (error) {
        localStorage.removeItem(BRANCH_LIST_CACHE_KEY);
        return null;
    }
}

export function setCachedBranches(branches) {
    localStorage.setItem(BRANCH_LIST_CACHE_KEY, JSON.stringify({
        branches: Array.isArray(branches) ? branches : [],
        expiresAt: Date.now() + BRANCH_LIST_CACHE_TTL_MS,
    }));
}

export function getCachedBranchSettings() {
    const rawCache = localStorage.getItem(BRANCH_SETTINGS_CACHE_KEY);
    if (!rawCache) {
        return null;
    }

    try {
        const parsedCache = JSON.parse(rawCache);
        if (!parsedCache || !Array.isArray(parsedCache.branches) || parsedCache.expiresAt <= Date.now()) {
            localStorage.removeItem(BRANCH_SETTINGS_CACHE_KEY);
            return null;
        }

        return parsedCache.branches;
    } catch (error) {
        localStorage.removeItem(BRANCH_SETTINGS_CACHE_KEY);
        return null;
    }
}

export function setCachedBranchSettings(branches) {
    localStorage.setItem(BRANCH_SETTINGS_CACHE_KEY, JSON.stringify({
        branches: Array.isArray(branches) ? branches : [],
        expiresAt: Date.now() + BRANCH_SETTINGS_CACHE_TTL_MS,
    }));
}

export function initBranchFetchInterceptor() {
    if (window.__branchFetchPatched) {
        return;
    }

    const originalFetch = window.fetch.bind(window);

    window.fetch = (input, init = {}) => {
        const requestUrl = typeof input === 'string' ? input : input?.url || '';
        const shouldAttachBranchHeader = typeof requestUrl === 'string'
            && (
                requestUrl.includes(config.REACT_APP_BASE_URL)
                || requestUrl.includes(config.REACT_APP_VERSION)
            );

        if (!shouldAttachBranchHeader) {
            return originalFetch(input, init);
        }

        const headers = new Headers(init.headers || (typeof input !== 'string' ? input.headers : undefined) || {});
        const branchId = getSelectedBranchId();

        if (branchId && branchId !== 'all' && !headers.has('x-branch-id')) {
            headers.set('x-branch-id', branchId);
        }

        return originalFetch(input, {
            ...init,
            headers: Object.fromEntries(headers.entries()),
        });
    };

    window.__branchFetchPatched = true;
}
